<template>
    <div>
        <div v-if="!questionSend">
            <div class="partners-title" v-if="!mode">
              Оставьте вашу заявку, чтобы мы могли связаться с вами для обсуждения возможных форматов сотрудничества.
            </div>
            <form v-if="!mode">
                <input
                        class="def-form-input"
                        type="text"
                        placeholder="Ваше имя"
                        v-model="params.fio"
                />
                <input
                        class="def-form-input"
                        type="text"
                        placeholder="Номер телефона"
                        v-model="params.phone"
                />
                <input
                        class="def-form-input"
                        type="text"
                        placeholder="Город"
                        v-model="params.city"
                />
                <input
                        class="def-form-input"
                        type="text"
                        placeholder="Почта для ответа"
                        v-model="params.email"
                />
                <textarea
                        class="def-form-textarea"
                        v-model="params.comment"
                        placeholder="Ваш комментарий"
                ></textarea>
                <div class=" def-form-checkbox">
                    <div class="radio-custom" @click="agreeWithPrivacy=true"
                         :class="{'active' : agreeWithPrivacy}"></div>
                    <label style="line-height: 1.5">
                        Согласие на обработку персональных данных в соответствии с
                        <a href="/privacy-policy"> политикой конфиденциальности </a>
                    </label>
                </div>
                <button type="button" @click="send()" class="btn-gray">
                    Отправить запрос
                </button>
            </form>

            <form class="contactsMess-form"  v-if="mode=='contact'">
                <div class="contactsMess-row">
                    <div class="contactsMess-col">
                        <div class="contactsMess-input">
                            <input
                                    class="def-form-input"
                                    type="text"
                                    placeholder="Ваше имя"
                                    v-model="params.fio"

                            />
                        </div>
                        <div class="contactsMess-input">
                            <input
                                    class="def-form-input"
                                    type="text"
                                    placeholder="Почта для ответа"
                                    v-model="params.email"

                            />
                        </div>
                    </div>
                    <div class="contactsMess-col">
                        <div class="contactsMess-input">
                        <textarea
                                class="def-form-textarea"
                                placeholder="Ваш вопрос"
                                v-model="params.comment"

                        ></textarea>
                        </div>
                    </div>
                </div>
                <div class="contactsMess-row">
                    <div class="contactsMess-pp def-form-checkbox">
                        <div class="radio-custom" @click="agreeWithPrivacy=true"
                             :class="{'active' : agreeWithPrivacy}"></div>
                        <label style="line-height: 1.5">
                            Согласие на обработку персональных данных в соответствии с
                            <a href="/privacy-policy"> политикой конфиденциальности </a>
                        </label>
                    </div>
                    <div class="contactsMess-col">
                        <button type="button" @click="send()" class="btn-gray">
                            Отправить запрос
                        </button>
                    </div>
                </div>
            </form>

        </div>
        <div class="bootstrap" v-else>
            <p>&nbsp;</p>
            <h4 class="text-center"> Ваш запрос успешно отправлен. Мы свяжемся с Вами. </h4>
            <p class="text-center"><a href="/catalog/top">Перейти в общий каталог</a></p>
            <p>&nbsp;</p>
        </div>

    </div>
</template>

<script>
    export default {
        name: "ContactForm",
        props: ['mode'],
        data() {
            return {
                questionSend: false,
                params: {},
                agreeWithPrivacy: false
            }
        },
        methods: {
            send() {
                let error = [];
                if (!this.params.fio) error.push('Не указано имя');
                if (!this.params.email) error.push('Не указан email');
                if (!this.params.comment) error.push('Не указан вопрос');
                if (!this.agreeWithPrivacy) error.push('Необходимо указать что Вы согласны с правилами обработкии персональных данных')

                if (error.length > 0) {
                    this.$modal.show('dialog', {
                        title: 'Ошибки в процессе заполнения',
                        text: '<ul class="order-errors-list"><li>' + error.join('</li><li>') + '</li></ul>',
                        buttons: [
                            {
                                title: 'Закрыть'
                            }
                        ]
                    })
                    return
                }
                this.$http.post('/customer/send/partnership', this.params).then(response => {
                    response
                    this.questionSend = true
                }, error => {
                  console.log(error)

                  this.$modal.show('dialog', {
                    title: 'Ошибка отправки сообщения',
                    text: error.data.detail,
                    buttons: [
                      {
                        title: 'Закрыть'
                      }
                    ]
                  })
                });

            }
        }
    }
</script>